<template lang="pug">
section.single
  Header
  .message(v-if="verified")
    p メールアドレスの登録が完了しました
  .container
    .box
      .header.text-center.mb-5.pb-3
        template(v-if="id")
          //-h1.title メールアドレス登録完了
          .text-center.mt-5
            p
              | メールアドレスの登録が完了しました。
              br
              | このまま基本情報の入力へ進んでください。
              br
            p.mt-5
              b-button(pill,variant="primary",@click="onNext()")
                // i.fas.fa-save
                span 基本情報の入力へ進む
            //-p.mt-4
              a(href="/")
                span キャンセル
        template(v-else)
          //-h1.title メールアドレス登録失敗
          .text-center.mt-5
            p メールアドレスの登録に失敗しました
            //-p.mt-5
              a(href="/")
                span トップページ
  Footer
</template>

<script>
import QueryHash from 'query-hash'
import { postData } from '../utils/api'

const page = {
  id: 'verify',
  title: '登録完了'
}

export default {
  data () {
    return {
      mask: false,
      page: page,
      verified: null,
      id: null,
      email: null
    }
  },
  async mounted () {
    let message = ''

    if (this.$route.query.code) {
      try {
        await postData('/verified', {
          code: this.$route.query.code
        }).then((datum) => {
          if (!datum) {
            this.$bvModal.msgBoxOk('メールアドレスが登録されていません')
          } else {
            this.id = datum._id
            this.email = datum.email.replace(/\+/g, '\u0002B')
            this.verified = datum.verified
          }
        }).catch((err) => {
          console.error(err)
          message = 'データの読込に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })
      } catch (e) {
        message = 'データの読込に失敗しました'
      }
    } else {
      message = 'Incorrect Access'
    }

    if (message) {
      this.msgBoxError(message)
    }
  },
  methods: {
    onNext () {
      let query = new QueryHash()
      query.add('code', this.$route.query.code)
      this.handleLink(`/initialSetting?${query.toQueryString()}`)
    }
  }
}
</script>

<style scoped lang="stylus">
</style>
